export const resourceSections = [
  {
    id: "what-provinces-do-you-loan-to",
    title: "What Provinces Do You Loan To?",
    description: "See where Swift Credit installment loans are available.",
    body: `Swift Credit provides Fast And Easy Access To Online loans in Every City And Remote Location In New Brunswick, Nova Scotia, Ontario, Manitoba, Saskatchewan, Alberta, British Columbia, and Newfoundland And Labrador.

`,
  },
  {
    id: "does-swift-credit-have-a-license",
    title: "Does Swift Credit have a License?",
    description: "Yes, Swift Credit is licensed where it operates across Canada.",
    body: `Yes, Swift Credit is licensed to provide lending services in every province and territory across Canada where we operate. We are committed to complying with all applicable provincial and territorial regulations. You can easily verify our specific license number for your province or territory at the header of our webpage. Our licensing underscores our dedication to providing a secure and trustworthy borrowing experience for all Canadians`,
  },
  
  {
    id: "do-you-accept-people-with-bad-credit",
    title: "Do you accept people with bad credit?",
    description: "Yes, approval is based on income and ability to repay.",
    body: `Yes! You can get a loan with Swift Credit with bad credit. Swift Credit does not
base your approval on a credit score, but on your income and ability to repay.`,
  },
  {
    id: "do-you-do-credit-checks",
    title: "Do You Do Credit Checks?",
    description: "Credit checks are optional and do not affect approval.",
    body: "No, a credit check is optional at Swift Credit. Everyone qualifies, regardless of credit score. While an optional credit check may increase your loan amount, it will never affect your loan approval",
  },
  {
    id: "when-is-swift-credit-open",
    title: "When is Swift Credit open?",
    description: "Automated approvals are 24/7 with support channels available.",
    body: "Swift Credit offers 24/7 automated loan approvals and instant deposits. Email support and live chat are available 2/47, and phone support from 9 am-5 pm EST",
  },
  {
    id: "how-do-i-apply-for-a-loan",
    title: "How do I apply for a loan?",
    description: "Apply in minutes from the Get a loan button on swiftcredit.co.",
    body: "Applying for a Loan with Swift credit is fast and simple.  Click on “Get a loan” on our website: https://swiftcredit.co and follow the instructions.  Applying for a loan takes only a few minutes. For assistance, email support@swiftcredit.co",
  },
  {
    id: "how-do-i-do-a-reloan",
    title: "How do I do a reloan?",
    description: "Sign in and reapply quickly after successful repayment.",
    body: "If you’ve successfully repaid your previous loan and are looking to borrow again, simply sign in to your account here Sign In. Reapplying is fast, easy, and typically takes just a minute. Get the funds you need quickly!",
  },
  {
    id: "who-is-swift-credit",
    title: "Who is Swift Credit?",
    description: "A Canadian lender for short-term installment loans.",
    body: "Swift Credit is a Canadian lender specializing in quick, short-term installment loans between $500 and $20000.  We offer a streamlined, paperless application process for fast and convenient access to funds, helping Canadians manage unexpected expenses.",
  },
  {
    id: "where-do-you-lend",
    title: "Where do you Lend?",
    description: "Installment loans in listed provinces.",
    body: `Swift Credit Provides Fast And Easy Access To Online Installment Loans In Every City And Remote Location In New Brunswick, Nova Scotia, Ontario, Manitoba, Saskatchewan, Alberta, British Columbia, and Newfoundland And Labrador.

`,
  },
  {
    id: "are-you-licensed",
    title: "Are you licensed?",
    description: "Yes, licensed in all provinces/territories where Swift Credit operates.",
    body: "Yes, Swift Credit is licensed in every Canadian province and territory where we operate, complying with all local regulations. You can easily find your specific provincial/territorial license number in our website header. This ensures a secure and trustworthy borrowing experience nationwide.",
  },
  {
    id: "minimum-eligibility-requirements",
    title: "Minimum Eligibility Requirements",
    description: "Basic age, income, and banking requirements.",
    body: `• You must be 18 years of age or older.
• You must have an established income that is on Direct Deposit.
• You must have a bank account open and in use for at least 30 days.`,
  },
  {
    id: "what-documents-do-i-need",
    title: "What Documents Do I Need For A Swift Credit Loan?",
    description: "Usually online and automated; documents may be required in some cases.",
    body: "Swift Credit loan application is mainly online and automated. However, if the automation encounters an error, you’ll need a bank statement, pre-authorized debit form, and photo ID. Saskatchewan residents must provide these documents.",
  },
  {
    id: "how-does-swift-credit-work",
    title: "How does Swift Credit work?",
    description: "Loan is repaid automatically on agreed repayment date.",
    body: "Swift Credit offers installment loans (between $500 – $20000), for customers needing funds. On the agreed repayment date, the repayment amount, including disclosed fees, is automatically debited from the borrower’s bank account.",
  },
  {
    id: "how-do-i-apply",
    title: "How do I apply?",
    description: "Apply online in minutes from swiftcredit.co.",
    body: "Applying for a Loan with Swift credit is fast and simple.  Click on “Get a loan” on our website: https://swiftcredit.co and follow the instructions.  Applying for a loan takes only a few minutes. For assistance, email support@swiftcredit.co",
  },
  {
    id: "can-i-get-a-loan-if-on-ei",
    title: "Can I get a loan from Swift Credit If I’m on EI or other Government benefits?",
    description: "EI lending is currently for returning customers with repayment history.",
    body: "Swift Credit lends on EI (Employment Insurance) for returning customers who have previously repaid loans. New loan applications on EI are not approved.",
  },
  {
    id: "what-income-qualify",
    title: "What Income qualify?",
    description: "Accepted income types include child tax credit, pension, disability, and eligible full-time employment.",
    body: `We loan on
• Child Tax Credit
• Pension,
• Disability,
• Full time employment: Some income types do require you to be employed for a minimum of 3 months. If you have been employed under 3 months, please wait until you have been employed for 3 months before applying.`,
  },
  {
    id: "can-i-have-more-than-one-loan",
    title: "Can I have more than one loan?",
    description: "No, provincial regulations allow one active loan at a time.",
    body: "Provincial regulations do not permit us to give a client more than one loan at a time.",
  },
  {
    id: "can-i-be-approved-with-other-loans",
    title: "Can I be approved for a loan if I have loans with other lenders?",
    description: "Yes, open loans with other lenders do not automatically disqualify you.",
    body: "Yes, Swift Credit does not reject a customer who has open loans with other Lenders.",
  },
  {
    id: "can-i-apply-over-phone",
    title: "Can I apply for a loan over the phone?",
    description: "No, applications must be completed online.",
    body: "Swift Credit is unable to accept application over the phone.  Applying is easy and automated, simply go to swiftcredit.co and click Get a Loan to apply.  It only takes a few minutes.",
  },
  {
    id: "can-i-get-an-increase-next-loan",
    title: "Can I get an Increase on my next Loan?",
    description: "Loan increases depend mainly on payment history and income.",
    body: "increases  to Swift Credit Loan are based on factors like payment history and income.  Consistent on-time payments are the most important factor to qualify for an increase.",
  },
  {
    id: "can-employee-increase-loan-amount",
    title: "Can an Swift Credit employee increase my loan amount?",
    description: "No, approved amounts are system-calculated and cannot be manually increased.",
    body: "The loan amount you are approved for is calculated based on our standard lending criteria. To maintain fairness and efficiency for all our customers nationwide, Swift Credit is unable to manually increase the approved loan amount.",
  },
  {
    id: "how-much-will-i-be-approved-for",
    title: "How Much will I be approved for?",
    description: "Amount depends on income, regulation, and responsible lending criteria.",
    body: "The amount of loan Swift Credit approves you for is based on your income, provincial regulations and Swift Credit’s commitment to responsible lending. We offer the maximum amount you qualify for initially, with potential increases based on your payment history.",
  },
  {
    id: "can-i-request-a-higher-amount",
    title: "Can I request a higher amount?",
    description: "No, approved amounts are automated and not manually overridden.",
    body: "The amount you have been approved for is determined by an automated system.  Swift Credit is unable to manually override this amount.",
  },
  {
    id: "is-there-an-application-fee",
    title: "Is there an application fee?",
    description: "No application fee, hidden fee, or membership fee.",
    body: "Swift Credit does not charge an application fee. Swift Credit has no hidden fees or membership fees.",
  },
  {
    id: "what-are-interest-rates-and-fees",
    title: "What are the interest rates and fees?",
    description: "Installment loans APR ranges are disclosed up front.",
    body: "Swift Credit charges 19.99% to 30.99% in APR. Overdue interest and NSF fees apply if payments are missed or fail.",
  },
  {
    id: "what-types-of-income-are-accepted",
    title: "What types of income are accepted?",
    description: "Accepted income includes eligible employment, child tax credit, pension, and disability.",
    body: `Swift Credit accepts
• Full time employment: Some income types do require you to be employed for a minimum of 3 months. If you have been employed under 3 months, please wait until you have been employed for 3 months before applying.
• Child Tax Credit
• Pension,
• Disability,`,
  },
  {
    id: "who-sends-code-for-banking-verification",
    title: "Who sends the code for banking verification?",
    description: "Your bank sends the verification code to your registered phone.",
    body: "When doing the application you will be required to verify your banking information.  You will be asked for a code.  That code will be sent to you from your bank. Please ensure your bank has the correct phone number to send you the code.  If you’re not receiving the code, please sign into your online bank and check the phone number.",
  },
  {
    id: "can-i-apply-if-self-employed",
    title: "Can I apply if I am self-employed?",
    description: "Yes, self-employed applicants may qualify based on eligible benefit income.",
    body: "Yes, you can apply for a loan with Swift Credit if you are self-employed. Although we cannot lend on your self-employment income, we can lend to you if you receive CPP, Child Tax Credit, Pension, or Disability benefits; you may still qualify. Our application process is fully online, paperless, and designed for quick approvals within minutes. Once approved, funds are transferred to your account within minutes.",
  },
  {
    id: "how-long-does-process-take",
    title: "How Long Does the Process Take?",
    description: "Applications can be completed in minutes with quick funding.",
    body: "Swift Credit offers quick online installment loan delivery. Using the bank verification tool, applications take minutes, with instant e-transfer funds.",
  },
  {
    id: "how-fast-can-i-get-my-loan",
    title: "How Fast Can I Get My Loan?",
    description: "Near-instant funding after signing, with bank-dependent timing.",
    body: "Swift Credit offers near-instant funding. E-transfer are typically sent to your account within one minute of signing. Some smaller banks may take a few hours. For these Banks, deposits before 11 AM PST arrive by 3:30 PM, 11 AM-3:45 PM by 8 PM, and after 3:45 PM or weekends and holidays by 3:30 PM the next business day.",
  },
  {
    id: "can-i-have-split-payments",
    title: "Can I have split payments?",
    description: "Split payments may be offered automatically when eligible.",
    body: "At Swift Credit, we are committed to operating in full compliance with all applicable provincial regulations across Canada. This ensures our lending practices meet the specific requirements and guidelines set forth by each province.  If you qualify for Split payments the system will offer them to you during the approval process.",
  },
  {
    id: "why-ontario-contract-say-more-money",
    title: "Why does my Ontario contract say I can get more money?",
    description: "Ontario contracts show a legal maximum, not final approved amount.",
    body: "In Ontario, provincial regulations require Swift Credit  to state a maximum potential loan amount on your contract, which is capped at 50% of your income. This is a regulatory requirement and not the actual amount you are approved for. The specific loan amount you qualify for is determined by our automated system, which considers various factors unique to your individual application, beyond just your income. Therefore, the 50% figure on your Ontario loan contract represents a legal maximum.",
  },
  {
    id: "why-approved-less-than-applied",
    title: "Why am I approved for less than I applied for?",
    description: "Approved amounts may be lower based on responsible lending criteria.",
    body: "Based on our review criteria, which considers various factors specific to your application, the approved loan amount may be lower than your request. This ensures responsible lending practices for all our customers across Canada. Please note that the amount you are ultimately approved for will never exceed the amount you initially applied for.",
  },
  {
    id: "my-contract-has-incorrect-information",
    title: "My contract has some incorrect information",
    description: "Email support if contract details are incorrect.",
    body: "If your Contract has incorrect information or if your unable to update your profile in your account settings, please email support@swiftcredit.co with the details.",
  },
  {
    id: "why-was-i-declined",
    title: "Why was I declined?",
    description: "Common decline reasons include income, banking, debt, and regulation checks.",
    body: `Our automated system carefully reviews each application based on several criteria to ensure responsible lending practices across Canada. There are some common reasons why your online Installment loan application with Swift Credit might have been declined.:
• Income Requirements Not Met: We have minimum income criteria to ensure you can comfortably repay the loan.
• Unstable Income: Consistent and verifiable income is important for loan approval.
• Banking Information Issues: Problems with your bank account can lead to a decline.
• Payment history: Previous repayment issues with us may affect your current application.
• High Existing Debt: Your overall debt obligations are considered during the review.
• Non-Compliance with Provincial Regulations: We adhere to all lending rules in each province we serve.

While our system makes automated decisions, if you believe there might be an error, please email us at support@swiftcredit.co with the details and explain why you think your application should have been approved.`,
  },
  {
    id: "why-havent-i-received-my-e-transfer",
    title: "Why haven’t I received my e-transfer?",
    description: "Transfers can be delayed by old auto-deposit setup, maintenance, or Interac security holds.",
    body: `There might be an occasional delay in receiving your Swift Credit e-Transfer for the following reasons:
• Email Address Linked to an Old Bank Account: If the email address associated with your e-Transfer is linked to a closed or inactive bank account, the transfer may be delayed. In this case, please contact us at support@swiftcredit.co so we can cancel the e-Transfer. You must also contact the bank where your old account was held and request they reject the e-Transfer. Additionally, ensure you have disabled e-Transfer auto-deposit for the old account and enabled it for your current bank account.
• Interac or Bank Maintenance: Scheduled maintenance on the Interac network or your bank’s online services can temporarily delay e-Transfers. These transfers will be processed as soon as the systems are back online.
• Temporary Security Hold by Interac Canada: Interac may place a temporary security hold on the e-Transfer for various undisclosed reasons. These holds are initiated by Interac Canada.

If you are experiencing a delay in receiving your Swift Credit e-Transfer and require assistance, please contact us at support@swiftcredit.co with the details of the issue.`,
  },
  {
    id: "what-is-the-e-transfer-password",
    title: "What is the e-Transfer password?",
    description: "The security answer is based on information you already know from your Swift Credit account.",
    body: `For your convenience and security, Swift Credit has set the answer to the security question for your e-Transfer to something you already know and related to your Swift Credit account. You do not need to contact us in advance to find out the answer. Simply attempt the e-Transfer deposit, and the answer should be obvious to you.`,
  },
  {
    id: "issue-with-e-transfer-password",
    title: "I have an issue with the e-transfer password.",
    description: "Contact support if you are locked out or unsure of the security answer.",
    body: `If you have entered the security question answer incorrectly multiple times and been locked out of depositing your e-Transfer, or if you are still unsure of the answer, please contact our support team for assistance at support@swiftcredit.co to help you resolve the issue and access your funds.`,
  },
  {
    id: "e-transfer-went-into-wrong-bank-account",
    title: "The e-transfer went into the wrong bank account. What do I do?",
    description: "Contact support and your old bank to reject the transfer and update auto-deposit.",
    body: `If the email address associated with your e-Transfer is linked to a closed or inactive bank account, the transfer may be delayed. In this case, please contact our support team at support@swiftcredit.co to cancel the e-Transfer. You must also contact the bank where your old account was held and request they reject the e-Transfer. Additionally, ensure you have disabled e-Transfer auto-deposit for the old account and enabled it for your current bank account.`,
  },
  {
    id: "can-you-send-e-transfer-to-different-email",
    title: "Can you send an e-transfer to a different email than the one I have on file?",
    description: "No, transfers can only be sent to the email currently on your account for security.",
    body: `For security reasons, we are unable to send your e-Transfer to a different email address than the one we currently have on file in your Swift Credit account.`,
  },
  {
    id: "how-do-i-update-my-email-address",
    title: "How do I update my email address?",
    description: "Sign in, open profile/security settings, and update your account email.",
    body: `To update the email address associated with your Swift Credit account, please sign in to your account on our website. Once logged in, navigate to your profile settings and follow the on-screen instructions to change your email address. If you are unable to access your account or encounter any difficulties updating your email, please contact our support team at support@swiftcredit.co.`,
  },
  {
    id: "can-you-use-different-bank-account-for-funding-and-repayment",
    title: "Can you put money in a different bank account than the one I repay you from?",
    description: "No, one verified account on file is used for both funding and repayment.",
    body: `For security reasons and to ensure a streamlined operation, Swift Credit maintains only one bank account on file for each client. This same bank account is used for both depositing your loan funds and processing repayment. Additionally, this bank account must be the account where your regular pay is directly deposited. This helps Swift Credit verify your income and protect against unauthorized transactions, ensuring a secure borrowing experience.`,
  },
  {
    id: "what-time-does-payment-come-out",
    title: "What time does the payment come out of my account?",
    description: "Payment is processed on your due date; exact timing is controlled by your bank.",
    body: `Swift Credit schedules your loan repayment to be processed on your agreed-upon due date. However, the exact time the funds are withdrawn from your bank account is determined by your financial institution based on their specific processing schedules. To ensure your repayment is successful and avoid potential issues or non-sufficient funds (NSF) fees, please ensure that the full repayment amount is available in your bank account for the entire day on your scheduled due date.`,
  },
  {
    id: "how-much-is-my-loan-balance",
    title: "How much is my loan balance?",
    description: "Sign in to your profile to view your current loan balance.",
    body: `To see your loan balance, please sign in to your Swift Credit profile.`,
  },
  {
    id: "how-do-i-pay-my-loan",
    title: "How do I pay my loan?",
    description: "Repayment is made through pre-authorized debit on your agreed due date.",
    body: `You pay your loan via a pre-authorized debit on your agreed-upon due date, as outlined in your Swift Credit loan contract. To avoid any potential issues, please ensure that the full repayment amount remains available in your bank account until at least the day after your scheduled payment date.`,
  },
  {
    id: "can-i-pay-loan-with-e-transfer",
    title: "Can I pay my loan with e-transfer?",
    description: "Generally no; e-transfer payment is only used for overdue or bank-account issues.",
    body: `When you take a loan from Swift Credit, you agree to have the payment debited automatically from your bank account. You can only pay by e-transfer if your loan is overdue or there is a problem with your bank account.`,
  },
  {
    id: "can-i-pay-early-and-reapply",
    title: "Can I pay early and re-apply?",
    description: "Early payment does not bypass your contract timeline for borrowing again.",
    body: `Because Swift Credit must adhere to the contract terms, paying your loan early will not enable you to borrow earlier. You will still need to wait until the agreed-upon due date in your contract before reborrowing.`,
  },
  {
    id: "why-funds-not-come-out-yet",
    title: "Why have the funds not come out of my bank account yet?",
    description: "Banks control posting time on due date; wait until midnight, then contact support if needed.",
    body: `Swift Credit schedules your loan repayment to be processed on your agreed-upon due date. However, the exact time of day the funds are withdrawn from your bank account is controlled by your financial institution based on specific processing schedules, which can occur in the morning, afternoon, or at night. Please wait until midnight of the payment date for the funds to come out. Please email support@swiftcredit.co if the funds have not come out by the next morning.`,
  },
  {
    id: "need-to-defer-payment-dates",
    title: "I need to defer my payment dates",
    description: "Payment dates cannot be deferred once agreed in your contract.",
    body: `Payment dates cannot be deferred as they are agreed upon based on the terms of the contract. Please ensure sufficient funds are available on your scheduled payment date.`,
  },
  {
    id: "my-payment-has-not-cleared",
    title: "My payment has not cleared.",
    description: "If payment fails, you’ll be notified by email and given rescheduling instructions.",
    body: `If your Swift Credit loan repayment does not clear with your bank, we are typically notified within 3 to 4 business days. Once we receive this notification, we will promptly send you an email to inform you that your payment needs to be rescheduled. This email will either provide you with a new scheduled payment date or instruct you to sign in to your Swift Credit account to reschedule the payment yourself. To reschedule your payment, please log in to your account on our website and follow the on-screen instructions. It’s important to reschedule your payment as soon as possible to avoid potential fees or negative impacts on your credit score.`,
  },
  {
    id: "how-do-i-reapply-for-a-loan",
    title: "How do I reapply for a loan?",
    description: "After successful repayment, sign in and reapply in about a minute.",
    body: `If you’ve successfully repaid your previous loan and are looking to borrow again, simply sign in to your account. Reapplying for a loan with Swift Credit is easy, swift, and typically takes about a minute.`,
  },
  {
    id: "why-do-i-have-to-wait-to-get-a-loan",
    title: "Why do I have to wait to get a loan?",
    description: "A regulated waiting period applies after payoff before you can borrow again.",
    body: `Swift Credit has a waiting period after your previous loan is fully paid to ensure responsible lending and compliance with provincial guidelines across Canada. A typical waiting period of 4 business days from the time your last repayment is processed is mandatory to confirm your previous loan has been paid in full.

For Manitoba residents: Due to provincial regulations in Manitoba, the waiting period is 7 days. The day your loan was paid off and the 7th day are not counted. This means in Manitoba, you need to wait until the 8th day, starting from the day after your loan was fully repaid, to apply for a new loan.`,
  },
  {
    id: "when-can-i-reapply-for-swift-credit-loan",
    title: "When can I reapply for a Swift Credit loan?",
    description: "Sign in to view your exact reloan eligibility date on your dashboard.",
    body: `To see when you can reapply for a loan, please sign in to your Swift Credit account. You will see the date on which you are eligible to reloan on your dashboard. Please note that this date cannot be changed.`,
  },
  {
    id: "how-do-i-change-my-email-address",
    title: "How do I change my email address?",
    description: "Use Security settings after sign-in, or contact support if you have issues.",
    body: `To update the email address associated with your account, please sign in to your Swift Credit account. Once logged in, navigate to Security settings and follow the on-screen instructions to change your email address. If you encounter any issues updating your email, please contact our support team at support@swiftcredit.co.`,
  },
  {
    id: "copy-of-my-loan-agreement",
    title: "Copy of My Loan Agreement.",
    description: "Download your agreement from My Account in loan history.",
    body: `To download a copy of your current Swift Credit loan agreement, please sign in to your Swift Credit account. Once logged in, navigate to “My Account”, then to loan history. Click on download loan agreement next to the loan of interest.`,
  },
  {
    id: "how-do-i-change-bank-account-details",
    title: "How do I change my bank account details?",
    description: "Email support with identity and new banking documentation.",
    body: `If you need to update the bank account information used for your Swift Credit loan repayments via pre-authorized debit, please contact our support team by emailing support@swiftcredit.co. For a streamlined process, please include the following information in your email:
• Your full name
• The email address associated with your Swift Credit account
• Clear instructions detailing the change you wish to make
• A copy of your new pre-authorized debit (PAD) form or a bank statement clearly showing your name, bank name, branch transit number, and account number.

Our support team will then guide you through the necessary steps to update your banking details. For help obtaining your pre-authorized debit form or statement, please contact your bank.`,
  },
  {
    id: "how-do-i-change-or-reset-password",
    title: "How do I change or reset my password?",
    description: "Sign in and use Security settings, or use forgot-password if needed.",
    body: `To update or reset your password, please sign in to your Swift Credit account. Once logged in, navigate to Security settings and follow the on-screen instructions to change or reset your password. If you encounter any issues, please contact our support team at support@swiftcredit.co.`,
  },
  {
    id: "how-do-i-change-address-and-phone-number",
    title: "How do I change my address and phone number?",
    description: "Update these details in My Profile after sign-in.",
    body: `To update your address or phone number with Swift Credit, please sign in to your account. Once logged in, navigate to My Profile, update your new address and/or phone number, and save the changes. Keeping your contact details up to date helps us reach you with important account information and updates.`,
  },
  {
    id: "how-do-i-delete-my-account",
    title: "How do I delete my account?",
    description: "Contact support to request account deletion.",
    body: `If you wish to delete your account, please contact our support team at support@swiftcredit.co.`,
  },
  {
    id: "trouble-signing-contract",
    title: "I am having trouble signing my contract",
    description: "Email support with a detailed issue description for help.",
    body: `If you are experiencing any difficulty signing your contract, please reach out to our support team at support@swiftcredit.co with a detailed description of the issue you’re encountering.`,
  },
  {
    id: "swift-credit-contact-information",
    title: "Swift Credit Contact Information",
    description: "Ways to reach Swift Credit support, including live chat, email, and mailing address.",
    body: `If you have any questions or feedback, please email our friendly team at support@swiftcredit.co and we will be happy to assist you.
Check our resources and frequently asked questions.

Mail:
Swift Chang Inc. d/b/a Swift Credit
10060 Jasper Ave, Tower 1, Suite 2020. Edmonton, AB T5J 3R8

Business Hours:
Instant loans are available through your account 24/7.
We answer emails 7am to 11 pm EST, 7 days a week.`,
    links: [
      {
        label: "Live Chat",
        type: "chat",
      },
      {
        label: "Email: support@swiftcredit.co",
        href: "mailto:support@swiftcredit.co",
      },
    ],
  },
];
